export const MYSELF_ONLY = 'Myself_only';
export const MYSELF_AND_SPOUSE = 'Myself_and_Spouse';
export const MYSELF_AND_ADDITIONAL_DRIVERS = 'Myself_and_Additional_Drivers';